import { connect } from "react-redux";
import PrintersCode from "../js/admin/PrintersCode";
import { withRouter } from "react-router-dom";
import EntityPage from "../components/EntityPage";


class Printers extends EntityPage {

    constructor() {
        super('admin_local.menus.printers');
        this.code = new PrintersCode()
    }

}
const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(Printers));
